import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit} from "react-icons/fa";

class ProxyAllInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            description: '',
            isChangeDescription: false,
        }
    }


    loadStatus = () => {
        if ( this.props.service.status === 'on' ) {
            return (
                <span className={ "text-success " + this.props.service.status}>
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status === 'off' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status === 'admin_off' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status === 'progressing' || this.props.service.status === 'waiting' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status === 'reset_password' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status === 'change_ip' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status === 'expire' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status === 'cancel' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status === 'delete' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status === 'change_user' ) {
            return (
                <span className={ "text-primary status-" + this.props.service.status}>
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    changeText = (event) => {
        this.setState({
            description: event.target.value
        })
    }

    submitChangeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
        this.props.submitChangeDescription( this.props.actionKey, this.state.description );
    }

    loadDescription = () => {
        if ( this.state.isChangeDescription ) {
            return (
                <>
                    <div className="form-group form-descripton">
                        <textarea rows="5" cols="12" maxLength="40" className="form-control" name="description" onChange={ this.changeText } />
                        <button type="button" name="button" className="close btn-close"
                                onClick={ () => this.changeDescription() }
                        >
                            <span>×</span>
                        </button>
                    </div>
                    <div className="text-right mt-2">
                        <button type="button" name="button" className="btn mr-1 btn-primary"
                                onClick={ () => this.submitChangeDescription() }
                        >
                            Thay đổi
                        </button>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    { this.props.service.description }
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Ghi chú
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <span className="btn-edit text-muted ml-2" onClick={ () => this.changeDescription() }>
                            <FaEdit />
                        </span>
                    </OverlayTrigger>
                </>
            )
        }
    }

    changeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                <Link to={'/dich-vu-proxy/' + this.props.service.id + '/chi-tiet-dich-vu.html'}>{this.props.service.ip}</Link>
                            </td>
                            <td>
                                {this.props.service.port}
                            </td>
                            <td>
                                { this.props.service.state }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                { this.props.service.text_next_due_date } - { this.props.service.text_day }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                { this.loadDescription() }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }
}

export default ProxyAllInfo;